export default {
  default: {
    panel: "border border-bordered rounded-md overflow-hidden",
    header:
      "flex justify-between items-center p-4 bg-primary text-text cursor-pointer",
    body: "bg-paper p-4",
    icon: "transition-transform duration-200 ease-in-out",
    titleVariant: "h4",
    titleClassName: "text-text",
  },

  primary: {
    panel: "border border-primary/30 rounded-md overflow-hidden",
    header:
      "flex justify-between items-center p-4 bg-primary text-text_inv cursor-pointer",
    body: "bg-paper p-4",
    icon: "transition-transform duration-200 ease-in-out",
    titleVariant: "h4",
    titleClassName: "text-text_inv",
  },

  secondary: {
    panel: "border border-bordered rounded-md overflow-hidden",
    header:
      "flex justify-between items-center p-4 bg-secondary/90 text-text cursor-pointer",
    body: "bg-paper p-4",
    icon: "transition-transform duration-200 ease-in-out",
    titleVariant: "h4",
    titleClassName: "text-text",
  },

  admin: {
    panel: "border border-admin_bordered rounded-md overflow-hidden",
    header:
      "flex justify-between items-center p-4 bg-admin_primary text-admin_text_inv cursor-pointer",
    body: "bg-admin_paper p-4",
    icon: "transition-transform duration-200 ease-in-out",
    titleVariant: "admin_h3",
    titleClassName: "text-admin_text_inv",
  },

  admin_info: {
    panel: "rounded-md overflow-hidden mb-0.5",
    header:
      "flex justify-between items-center p-4 bg-admin_info_bg text-admin_text cursor-pointer",
    body: "bg-admin_paper p-4",
    icon: "transition-transform duration-200 ease-in-out",
    titleVariant: "admin_label",
    titleClassName: "text-admin_text my-0",
  },

  flat: {
    panel: "rounded-md overflow-hidden",
    header:
      "flex justify-between items-center p-4 bg-primary/10 text-text_secondary cursor-pointer",
    body: "bg-paper p-4",
    icon: "transition-transform duration-200 ease-in-out",
    titleVariant: "h4",
    titleClassName: "text-text_secondary",
  },

  bordered: {
    panel: "border border-bordered rounded-md overflow-hidden",
    header:
      "flex justify-between items-center p-4 bg-paper border-b border-bordered text-text cursor-pointer",
    body: "bg-paper p-4",
    icon: "transition-transform duration-200 ease-in-out",
    titleVariant: "h4",
    titleClassName: "text-text",
  },
  admin_bordered: {
    panel: "border border-admin_bordered rounded-md overflow-hidden bg-admin_paper",
    header:
      "flex justify-between items-center p-4 bg-admin_paper border-b border-admin_bordered text-admin_text cursor-pointer",
    body: "bg-admin_paper p-4",
    icon: "transition-transform duration-200 ease-in-out",
    titleVariant: "admin_h4",
    titleClassName: "text-admin_text",
  },

  admin_bordered_shadow: {
    panel: "border border-admin_bordered rounded-md overflow-hidden",
    panelOpen: "border border-admin_bordered rounded-md overflow-hidden shadow-lg",
    header:
      "flex justify-between items-center p-4 bg-admin_paper border-b border-admin_bordered text-admin_text cursor-pointer",
    body: "bg-admin_paper p-4 overflow-y-auto scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper",
    icon: "transition-transform duration-200 ease-in-out",
    titleVariant: "admin_h4",
    titleClassName: "text-admin_text",
  },

  simple: {
    panel: "rounded-md overflow-hidden",
    header:
      "flex justify-between items-center p-4 bg-neutral text-text cursor-pointer",
    body: "bg-paper p-4",
    icon: "transition-transform duration-200 ease-in-out",
    titleVariant: "h4",
    titleClassName: "text-text",
  },
}
